export default "__VITE_ASSET__t_ZhLmwq__"